import Transform from '@ember-data/serializer/transform';
export default class YearMonthDayTransform extends Transform {
  deserialize(serialized) {
    const {
      year,
      month_of_year,
      day_of_month
    } = serialized;
    return {
      year,
      monthOfYear: month_of_year,
      dayOfMonth: day_of_month
    };
  }
  serialize(deserialized) {
    const {
      year,
      monthOfYear,
      dayOfMonth
    } = deserialized;
    return {
      year,
      month_of_year: monthOfYear,
      day_of_month: dayOfMonth
    };
  }
}